const r=(r,t,e)=>{if(!r)return e;const o=Array.isArray(t)?t:t.replace(/\[(\d+)\]/g,".$1").split(".").filter(Boolean);let l=r;for(const r of o){if(null==l||!Object.prototype.hasOwnProperty.call(l,r))return e;l=l[r]}return l};export{r as get};
//# sourceMappingURL=get.js.map
